<template>
  <div class="middle cadfm-flexitem-stretched">
    <action-panel>
      <action-bar>
        <b-navbar-nav>

          <action-button @click="back" icon="back" bold :text="lang.button_Back" :tooltip="lang.button_Back"
            :disabled="backButtonStatus" />
          <action-button @click="checkMapping" icon="import" bold :text="lang.button_ImportBom"
            :tooltip="lang.button_ImportBom" :disabled="importButtonStatus" />



        </b-navbar-nav>
        <b-navbar-nav class="ml-auto">
          <action-button v-show="!$parent.isVisibleLeft" @click="toggleLeftPanel" icon="show" bold
            :text="lang.button_Left" :tooltip="lang.button_Left" :disabled="toggleButtonStatus" />
          <action-button v-show="!$parent.isVisibleRight" @click="toggleRightPanel" icon="show" bold
            :text="lang.button_Right" :tooltip="lang.button_Right" :disabled="toggleButtonStatus" />

        </b-navbar-nav>
      </action-bar>
      <action-content>
        <Content :lang="lang.Content"></Content>
      </action-content>
    </action-panel>
  </div>
</template>

<script>
  import ActionBar from '@/components/shared/ActionBar'
  import ActionButton from '@/components/shared/ActionButton'
  import ActionContent from '@/components/shared/ActionContent'
  import ActionPanel from '@/components/shared/ActionPanel'


  import Content from "@/components/ProjectManager/Views/ProjectImportBom/Middle/Content/Content"

//import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'

export default {
  name: 'Middle',
  components:{
    ActionBar,
    ActionButton,
    ActionContent,
    ActionPanel,
    Content

  },
  props:{
    lang: Object
  },

  data () {
    return {
      toggleButtonStatus: false,
      importButtonStatus: true,
      backButtonStatus: false,
      imported: false,
      delimiter: ",",
      defaultRevision: false
    }
  },
  computed:{
    lengthMapped(){
      
      if (this.$store.getters.mappedFields.length > 0 && this.$store.getters.bomDescription.name.length > 0){
         this.importButtonStatus = false;
      }else{
         this.importButtonStatus = true;
      }
      return this.$store.getters.mappedFields.length;
    },
    currentRevisionHistory() {
      let revisionId = "";
      for (let i = 0, lei = this.$store.getters.revisionHistory.length; i < lei; i++){
        if (this.$store.getters.revisionHistory[i].status.display == "pending") {
          revisionId = this.$store.getters.revisionHistory[i].id;
          break;
        }

      }
      return revisionId;
    },
    lastRevisionHistory() {
      if (this.$store.getters.revisionHistory == null) {
        return
      }
      let tab = this.$store.getters.revisionHistory;
      let obj = tab[0];
      for (let i = 0, lei = tab.length; i < lei; i++) {

        if (tab[i].revision > obj.revision) {
          obj = tab[i];
        }
      }

      return obj;
    },
    

  },
  created() {

    this.importButtonStatus = true;
  },
  watch: {
    lengthMapped: function(newVal, oldVal){
      
      if (newVal > 0){
         this.importButtonStatus = false;
      }else{
         this.importButtonStatus = true;
      }
     
    }

  },
  methods: {
    setSeparator(delimiter){
      
      this.delimiter = delimiter;
    },
    checkMapping() {

      let _vue = this;

      let mappingStatus = [];
      for (let i = 0, lei = this.$store.getters.bomProperties.length; i < lei; i++) {
        let obj = {
          name: this.$store.getters.bomProperties[i].name,
          propertyId: this.$store.getters.bomProperties[i].propertyId,
          present: false
        }
        mappingStatus.push(obj);
      }
      
      for (let i = 0, lei = mappingStatus.length; i < lei; i++) {

        
        for (let j = 0, lej = this.$store.getters.mappedFields.length; j < lej; j++) {
          
          if (this.$store.getters.mappedFields[j].propertyId == mappingStatus[i].propertyId) {

            mappingStatus[i].present = true;
          }
          
        }
      }
      
      let statusPartNumber = false;
      let statusPartReference = false;
      let statusRevision = false;
      let str = "";
      for (let i = 0, lei = mappingStatus.length; i < lei; i++) {
        if (mappingStatus[i].name == "Part number") {
          if (mappingStatus[i].present == true) {
            statusPartNumber = true;
            
          } else {
            str += mappingStatus[i].name + ", ";
          }
        }
        if (mappingStatus[i].name == "Part reference") {
          if (mappingStatus[i].present == true) {
            statusPartReference = true;
            
          } else {
            str += mappingStatus[i].name + ", ";
          }
        }
        if (mappingStatus[i].name == "Revision") {
          if (mappingStatus[i].present == true) {
            statusRevision = true;
            
          } else {
            str += mappingStatus[i].name + ", ";
          }
        }
      }
        
        

      
      let funcYes = function () {
        
        //_vue.defaultRevision = true;
        //_vue.importing();

        if (statusRevision == false) {

          let funcYesRev = function () {
            _vue.defaultRevision = true;
            _vue.importing();
          }

          let funcNoRev = function () {
            _vue.defaultRevision = false;
            _vue.importing();
          }

          var obj = {
            title: _vue.lang.title_import_revision,
            text: _vue.lang.alert_text_revision,
            text2: "",
            type: "info",
            buttons: 2,
            size: "sm",
            funcYes: funcYesRev,
            funcNo: funcNoRev
          }
          _vue.$store.dispatch("showAlert", obj);
        } else {
          _vue.defaultRevision = false;
          _vue.importing();
        }
      }
      let funcNo = function () {
        
      }
      
      
      if (statusPartNumber == false || statusPartReference == false || statusRevision == false) {
        
        var obj = {
          title: _vue.lang.title_import,
          text: _vue.lang.alert_text_mapping,
          text2: "",
          type: "info",
          buttons: 2,
          size: "sm",
          funcYes: funcYes,
          funcNo: funcNo
        }
        _vue.$store.dispatch("showAlert", obj);
      }
      
      
      
      
      if (statusPartNumber == true && statusPartReference == true && statusRevision == true) {
        this.defaultRevision = false;
        this.importing();
      }
      
      
      
    },
    importing(){
      

      let _vue = this;


   

      var obj = {
        revisionId: this.lastRevisionHistory.id,
        documentId: this.$store.getters.importedFileId,
        description: this.$store.getters.bomDescription.description,
        name: this.$store.getters.bomDescription.name,
        bomNumber: this.$store.getters.bomDescription.bomNumber,
        mapped: this.$store.getters.mappedFields,
        separator: this.delimiter,
        defaultRevision: this.defaultRevision
        }

      this.$store.dispatch("showLoader", {visible: true, text: "load"});

      this.$store.dispatch(this.$store.getters.sectionPrefix+"_MappingImportedBomExtended", obj)
        .then(function(result){

          console.log(result)

          

          if (result.status == "OK"){

            _vue.imported = true;

            let obj = {
              text: _vue.lang.alert_success_import,
              time: 5,
              type: "success"
            }

            _vue.$store.dispatch("displayFooterAlert", obj)

            _vue.$store.dispatch(_vue.$store.getters.sectionPrefix +"_resetMapField");

            const reloadObj = {
                status: true,
                name: "BomsProjectTableComponent"
            }
            _vue.$store.dispatch("reloadAfterActionComplex", reloadObj);


            _vue.back();

          }else{

            let obj = {
              text: _vue.lang.alert_error_import + " Error: " + result.message,
              time: 10,
              type: "danger"
            }

            _vue.$store.dispatch("displayFooterAlert", obj)


          }


      })
      .then(function() {
        
        _vue.$store.dispatch("showLoader", {visible: false});
        
      })



    },
    back(){


      

      //#####################################################################
      let query = {};
      let to = "";
      
      if (this.$store.getters.routingData.length == 0) {
        if (this.$store.getters.sectionPrefix == "pm") {
          to = "/PartManager/PartTable";
        }
        if (this.$store.getters.sectionPrefix == "lm") {
          to = "/LibraryManager/LibraryTable";
        }
        if (this.$store.getters.sectionPrefix == "projm") {
          if (this.$route.path == "ProjectManager/ProjectBom") {
            to = "/ProjectManager/ProjectDetails";
          } else {
            to = "/ProjectManager/ProjectTable";
          }

        }


      } else {
        to = this.$store.getters.routingData[this.$store.getters.routingData.length - 1].from;
        if (this.$store.getters.routingData[this.$store.getters.routingData.length - 1].end == true) {
          if (this.$store.getters.sectionPrefix == "pm") {
            to = "/PartManager/PartTable";
          }
          if (this.$store.getters.sectionPrefix == "lm") {
            to = "/LibraryManager/LibraryTable";
          }
          if (this.$store.getters.sectionPrefix == "projm") {
            if (this.$route.path == "ProjectManager/ProjectBom") {
              to = "/ProjectManager/ProjectDetails";
            } else {
              to = "/ProjectManager/ProjectTable";
            }
          }

        }

        query = {
          from: this.$store.getters.routingData[this.$store.getters.routingData.length - 1].to,
          to: to,
          end: this.$store.getters.routingData[this.$store.getters.routingData.length - 1].end,
          revisionId: this.$store.getters.routingData[this.$store.getters.routingData.length - 1].sourceRevisionId,
          id: this.$store.getters.routingData[this.$store.getters.routingData.length - 1].sourceId
        }
        if (this.$store.getters.routingData[this.$store.getters.routingData.length - 1].sourceType == "main") {
          query = {};
        } else if (this.$store.getters.routingData[this.$store.getters.routingData.length - 1].sourceType == "details") {
          const goalObj = {
            to: to,
            revisionId: this.$store.getters.routingData[this.$store.getters.routingData.length - 1].sourceRevisionId,
            id: this.$store.getters.routingData[this.$store.getters.routingData.length - 1].sourceId,
            selectedBomRow: [{ bomId: this.$store.getters.routingData[this.$store.getters.routingData.length - 1].bomId }],

          }
          this.selectRow(goalObj);
        }

        this.$store.commit("BACKROUTINGDATA");
      }


     
      this.$router.push({ path: to, query: query }) 

    },
    selectRow(goalObj) {
      

      
      this.$store.dispatch("projm_setSelectedBomRow", goalObj.selectedBomRow)

      let obj = {};

      if (goalObj.to == "/PartManager/PartDetails") {
        obj = {
          col___revisionId: {
            revisionId: goalObj.revisionId,
            partId: goalObj.id,
            value: {
              display: ""
            }
          },
          col___revision: {
            revisionId: goalObj.revisionId,
            partId: goalObj.id,
            value: {
              display: ""
            }
          },
          col___status: {
            revisionId: goalObj.revisionId,
            partId: goalObj.id,
            value: {
              display: ""
            }

          },
          col___name: {
            revisionId: goalObj.revisionId,
            partId: goalObj.id,
            value: {
              display: ""
            }

          },
          col___image: {
            revisionId: goalObj.revisionId,
            partId: goalObj.id,
            value: {
              display: ""
            }
          },

        }
      }

      if (goalObj.to == "/LibraryManager/LibraryDetails") {
        let id = goalObj.id;

        obj = {
          col___revisionId: {
            revisionId: goalObj.revisionId,
            libraryId: id,
            userId: goalObj.userId,
            value: {
              display: goalObj.revisionId
            }
          },
          col___revision: {
            revisionId: goalObj.revisionId,
            libraryId: id,
            value: {
              display: goalObj.revision
            }
          },
          col___status: {
            revisionId: goalObj.revisionId,
            libraryId: id,
            value: {
              display: ""
            }

          },
          col___name: {
            revisionId: goalObj.revisionId,
            libraryId: id,
            value: {
              display: ""
            }

          },
          col___libraryType: {
            revisionId: goalObj.revisionId,
            libraryId: id,
            value: {
              display: ""
            }

          },
          col___image: {
            revisionId: goalObj.revisionId,
            libraryId: id,
            value: {
              display: ""
            }
          },

        }
      }

      if (goalObj.to == "/ProjectManager/ProjectDetails") {
        obj = {
          col___revisionId: {
            revisionId: goalObj.revisionId,
            projectId: goalObj.id,
            value: {
              display: ""
            }
          },
          col___revision: {
            revisionId: goalObj.revisionId,
            projectId: goalObj.id,
            value: {
              display: ""
            }
          },
          col___status: {
            revisionId: goalObj.revisionId,
            projectId: goalObj.id,
            value: {
              display: ""
            }

          },
          col___name: {
            revisionId: goalObj.revisionId,
            projectId: goalObj.id,
            value: {
              display: ""
            }

          },
          col___image: {
            revisionId: goalObj.revisionId,
            projectId: goalObj.id,
            value: {
              display: ""
            }
          },

        }
      }




      this.$store.dispatch("deleteAllSelectedRows");
      this.$store.dispatch("setSelectedRows", [obj]);

      this.$store.dispatch("setOuterData", true);

      this.$store.dispatch("editPropertiesForm", false);
    },
    toggleRightPanel(){
     
      this.$parent.isVisibleRight = !this.$parent.isVisibleRight;
      
    },
    toggleLeftPanel(){
      
      this.$parent.isVisibleLeft = !this.$parent.isVisibleLeft;
      
    }
  }
}
</script>


<style scoped>

  .middle{
    border-right: 1px solid #666;
  }

</style>



// WEBPACK FOOTER //
// src/components/ProjectManager/Views/ProjectImportBom/Middle/Middle.vue